module.exports = require("core-js-pure/features/object/get-own-property-names");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/get-own-property-names.js
// module id = 490
// module chunks = 13